/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Error_ShortInputs */



/**
* | output |
* | --- |
* | "Couldn't load voices" |
*
* @param {Voice_Manager_Elevenlabs_Error_ShortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_error_short = /** @type {((inputs?: Voice_Manager_Elevenlabs_Error_ShortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Error_ShortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger les voix")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stimmen konnten nicht geladen werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare le voci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось загрузить голоса")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron cargar las voces")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法加载语音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声を読み込めませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवाज़ें लोड नहीं हो सकीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível carregar as vozes")
	return /** @type {LocalizedString} */ ("Couldn't load voices")
});